module.exports = __webpack_public_path__ + "static/logo-d188ae7a1bf2cfc19472565b7edf5047.png";